import { render, staticRenderFns } from "./Popularize.vue?vue&type=template&id=1b41a17a"
import script from "./Popularize.vue?vue&type=script&lang=js"
export * from "./Popularize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports